export const Mode = Object.freeze({
	BLANK_TABLE_CELL: "blank_table_cell",
	BRANCH_EDIT: "branch_edit",
	BRANCH_SELECT: "branch_select",
	TABLE_CELL: "table_cell",
	TABLE_HEADER: "table_header",
	BAR_GRAPH_HEADER: "bar_graph_header",
	STANDARD: "standard",
});
